export default __webpack_public_path__ + "static/media/BSI-Installation.d111f97e.jpg";